import {DatePipe} from '@angular/common';

export class DateTimeUtils {

    private static today: Date;
    private static tomorrow: Date;

    public static DateToRestString(date: any): string {

        // console.log('DateToRestString', date);

        if (date instanceof Date) {
            const offset = Math.abs(date.getTimezoneOffset());
            const hours = Math.floor(offset / 60);
            const minutes = offset % 60;
            date.setHours(hours, minutes, 0, 0);
            return (date as Date).toISOString().replace(/\.\d+/, '');
        }

        if (typeof date === 'string') {
            // return date.replace(/\.\d+/, '');
            return new DatePipe('de_DE').transform(date, 'yyyy-MM-dd') + 'T00:00:00Z';
        }
        return undefined;
    }


    public static DateTimeToRestString(dateTime: any): string {
        if (dateTime instanceof Date) {
            const groups = dateTime.toLocaleDateString('de').match(/(\d{1,2})\.(\d{1,2})\.(\d{1,4})/);
            const timeString = groups[3] + '-' + ('0' + groups[2]).slice(-2) + '-' + ('0' + groups[1]).slice(-2) + 'T' +
                ('0' + dateTime.getHours()).slice(-2) + ':' +
                ('0' + dateTime.getMinutes()).slice(-2) + ':' +
                ('0' + dateTime.getSeconds()).slice(-2) + 'Z';
            return timeString;
        }

        if (typeof dateTime === 'string') {
            return new DatePipe('de_DE').transform(dateTime, 'yyyy-MM-dd') + 'T' +
                new DatePipe('de_DE').transform(dateTime, 'HH:mm:ss') + 'Z';
        }
        return undefined;
    }


    public static StringToDate(sDate: string): Date {
        if (sDate && typeof sDate === 'string') {
            return new Date(sDate);
        } else {
            return null;
        }
    }


    public static getNextWorkingDate(date?: Date): Date {
        const d: Date = date ? new Date(date.getTime()) : new Date();
        d.setDate(d.getDate());
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + 1); // increase to tomorrow
        if (d.getDay() === 0) { // tomorrow is sunday
            d.setDate(d.getDate() + 1);
        } else if (d.getDay() === 6) {  // tomorrow is wednesday
            d.setDate(d.getDate() + 2);
        }
        return d;
    }


    public static getNext5YearsDate(): Date {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const next5YearsNumber = today.setFullYear(today.getFullYear() + 5);
        return new Date(next5YearsNumber);
    }


    /**
     * returns true if both dates are defined and difference between dates is lower then 5 years
     * @param startDate
     * @param endDate
     */
    public static isMax5YearsDifference(startDate: Date, endDate: Date): boolean {
        if (startDate && endDate) {
            const fiveYearsDate = new Date();
            fiveYearsDate.setTime(startDate.getTime());
            fiveYearsDate.setHours(0, 0, 0, 0);
            fiveYearsDate.setFullYear(startDate.getFullYear() + 5);

            const endDateCopy = new Date();
            endDateCopy.setTime(endDate.getTime());
            endDateCopy.setHours(0, 0, 0, 0);
            const difference = endDateCopy.getTime() - fiveYearsDate.getTime();
            return difference <= 0;
        } else {
            return false;
        }

    }


    public static getTodayDate(): Date {
        if (!DateTimeUtils.today) {
            let today = new Date(Date.now());
            today.setHours(0, 0, 0, 0);
            DateTimeUtils.today = today;
        }

        return new Date(DateTimeUtils.today);
    }

    public static getTomorrowDate(): Date {
        if (!DateTimeUtils.tomorrow) {
            DateTimeUtils.tomorrow = DateTimeUtils.getTodayDate();
            DateTimeUtils.tomorrow.setDate(DateTimeUtils.tomorrow.getDate() + 1);
        }

        return new Date(DateTimeUtils.tomorrow);
    }
}
